// extracted by mini-css-extract-plugin
export default {"overlay":"Drawer_overlay__osmU-","drawer":"Drawer_drawer__2W-kK"};